import React from 'react'
import PropTypes from 'prop-types'
import isNil from 'lodash/isNil'
import { compose, branch, withProps, renderNothing, getContext } from 'recompose'
import { getAssets } from './utils/withAssets'
import { getRouter } from './utils/withRouter'
import withRender from './utils/withRender'

const withContextElement = () => compose(
  getContext({ elementById: PropTypes.object.isRequired }),
  getAssets(),
  getRouter(),
  withProps(
    ({ elementById, elementId, ...props }) => ({
      element: elementById[elementId],
      ...props,
    }),
  ),
  branch(
    (element) => isNil(element),
    renderNothing,
  ),
  withRender(),
)

export default withContextElement



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/withContextElement.js